<section>
  <h3>{{"dashboard:Report Settings" | i18next}}</h3>
  <div class="section-content settings-content">
    <div>
      <div>
        <app-reports-date-picker [gridItem]="gridItem" (setPeriod)="setPeriod($event)" [showTitle]="true" [firstDate]="report?.firstDate"
                                [dataAvailableFor]="report?.dataAvailableFor" [(data)]="rdp_data">
        </app-reports-date-picker>
      </div>
      <div>
        <span class="settings-sub-title empty"></span>
        <div>
          <button matButton class="secondary-button" (click)="settingsExpanded=!settingsExpanded">
            <ng-container *ngIf="settingsExpanded">{{ 'dashboard:Hide Settings' | i18next }}</ng-container>
            <ng-container *ngIf="!settingsExpanded">{{ 'dashboard:Show Settings' | i18next }}</ng-container>
          </button>
        </div>
      </div>
      <div>
        <span class="settings-sub-title empty"></span>
        <div>
          <button matButton class="primary-button" (click)="viewReport()" [disabled]="!isViewButtonVisible">
            {{ 'dashboard:View Report' | i18next }}
          </button>
        </div>
      </div>
    </div>
    <div [@collapse]="!settingsExpanded" class="flex wrap settings-expanded">
      <h5>{{ 'dashboard:Additional Settings' | i18next}} </h5>
      <div class="half-row">
        <app-widget-report-select [items]="ruleItems" bindLabel="ruleName" [model]="gridItem.setup.ruleIds" title="{{ 'dashboard:Select Rules' | i18next }}"
                                  bindValue="ruleId" [(exclude)]="gridItem.setup.excludeRules" (modelChange)="rulesModelChanged($event)"
                                  (excludeChange)="visualTypeCheck()" class="filter-select">
        </app-widget-report-select>
      </div>
      <div class="half-row">
        <app-widget-report-select [items]="interactionItems" bindLabel="interactionName" [model]="gridItem.setup.interactionIds" title="{{ 'dashboard:Select Interactions' | i18next }}"
                                  bindValue="interactionId" [(exclude)]="gridItem.setup.excludeInteractions" (modelChange)="interactionsModelChanged($event)"
                                  (excludeChange)="visualTypeCheck()" class="filter-select">
        </app-widget-report-select>
      </div>
      <app-widget-report-columns-select [items]="columns" class="half-row" bindLabel="shortDescription" [model]="gridItem.setup.columns" [defaultColumns]="defaultColumns" [disabledColumns]="disabledColumns"
                                        title="{{ 'dashboard:Select Columns' | i18next }}" bindValue="labelCode" (modelChange)="columnsModelChange($event)">
      </app-widget-report-columns-select>
      <app-widget-type-select [widgetType]="gridItem.type" [showTooltip]="true" (modelChange)="visualTypeModelChange($event)" class="half-row"
                              title="{{ 'dashboard:Visual Type' | i18next }}" [disabledItems]="visualTypeDisabledItems" hideLabelType="true">
      </app-widget-type-select>
      <div class="half-row">
        <div class="mr5">
          <div class="title ml5">{{ 'dashboard:Group by time' | i18next }}</div>
          <ng-select [items]="sysGroupByTime" bindLabel="value" bindValue="key" [(ngModel)]="gridItem.setup.sysGroupByTime" placeholder="{{ 'Select'| i18next }}"
                     [searchable]="false" class="group-select" (change)="groupingModelChange($event)">
            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index" dropdownPosition="bottom">
              <span>{{item.value}}</span>
            </ng-template>
            <ng-template ng-label-tmp let-item="item">
              <span class="item">{{item?.value}}</span>
            </ng-template>
          </ng-select>
        </div>
      </div>
      <!--<div [class]="filtersLengthIsEven()?'column-order-row-odd':'column-order-row-even'" *ngIf="showColumnButton && this.gridItem.type === 4">-->
      <div class="half-row" *ngIf="showColumnButton && this.gridItem.type === 4">
        <button matButton [ngClass]="['arrange-columns-button', 'secondary-button']" (click)="showColumnOrder=true">
          <i class="fal fa-cog button-cog"></i> {{ 'dashboard:Column order' | i18next }}
        </button>
        <div class="column-order-wraper" *ngIf="showColumnOrder">
          <div class="column-order-container"></div>
          <div class="column-order-inner-container">
            <div class="column-order-header">
              <i class="fal fa-cog"></i>
              <span style="flex-grow: 1;">{{ 'dashboard:Column order' | i18next }}</span>
              <i class="fal fa-times-circle" (click)="showColumnOrder=false"></i>
            </div>
            <app-column-order [gridItem]="gridItem" [columns]="columns" (columnOrderEvent)="columnOrderEvent($event)"></app-column-order>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="section-content-expand">
    <div (click)="settingsExpanded=!settingsExpanded">
      <i class="far fa-chevron-down" [class.fa-chevron-up]="settingsExpanded"></i>
    </div>
  </div>
</section>
